/**
 * Network status banner - shows when the user is offline
 */

import { useNativeNetwork } from '../hooks/useNativeNetwork';
import { useTranslation } from '../context/LanguageContext';
import { WifiOff } from 'lucide-react';

export function NetworkStatus() {
  const { isConnected } = useNativeNetwork();
  const { t } = useTranslation();

  if (isConnected) return null;

  return (
    <div 
      data-testid="network-offline-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white text-center px-4 flex items-center justify-center gap-2 text-sm font-medium"
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 8px)',
        paddingBottom: '8px',
      }}
    >
      <WifiOff className="w-4 h-4" />
      <span>{t('offlineBanner', 'Sei offline — visualizzi i contenuti salvati.')}</span>
    </div>
  );
}
